import * as authSelectors from '@redux/reducers/auth';
import camelcaseKeys from 'camelcase-keys';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getEventActivityDropdown } from '../services';

const useGetEventActivityDropdown = (
  organizationId?: number | undefined,
  getAllEvents?: boolean
): {
  eventTypes: any;
  isFetchingEventTypes: boolean;
} => {
  const userOrganizationId = useSelector(authSelectors.getAuthUserForMembership).organizationId;
  const [eventTypes, setEventTypes] = useState<any>([]);
  const [isFetchingEventTypes, setIsFetching] = useState<boolean>(false);
  useEffect(() => {
    if (organizationId || userOrganizationId || getAllEvents) {
      setIsFetching(true);
      getEventActivityDropdown(
        getAllEvents
          ? {}
          : {
              organizationId: organizationId ?? userOrganizationId
            },
        {
          errorAction: () => {
            setEventTypes([]);
            setIsFetching(false);
          },
          successAction: (response) => {
            if (response && response?.data && response?.data?.length > 0) {
              setEventTypes(
                response.data.map((eventActivity) => {
                  return camelcaseKeys({
                    ...eventActivity
                  });
                })
              );
            } else setEventTypes([]);
            setIsFetching(false);
          }
        }
      );
    }
  }, [organizationId, userOrganizationId, getAllEvents]);
  return { eventTypes, isFetchingEventTypes };
};

export default useGetEventActivityDropdown;
